import { createStyles } from "@mantine/emotion";

export const useStylesAccordion = createStyles((theme) => ({
  accordion: {
    ".mantine-Accordion-item": {
      border: theme.customColors.accordionPlusBorder,
      borderRadius: theme.spacing.accordionNew.itemBorderRadius,
    },
    ".mantine-Accordion-control": {
      position: "relative",
      paddingRight: theme.spacing.accordionNew.controlPaddingRight,
      svg: {
        strokeWidth: theme.spacing.accordionNew.controlSvgStrokeWidth,
      },
    },
    ".mantine-Accordion-chevron": {
      position: "relative",
      right: theme.spacing.accordionNew.chevronRight,
      zIndex: theme.spacing.accordionNew.chevronZIndex,
    },
    ".show-hide": {
      fontFamily: theme.headings.fontFamily.light,
      fontSize: theme.spacing.accordionNew.showHideFontSize,
      marginLeft: theme.spacing.accordionNew.showHideMarginLeft,
      paddingTop: theme.spacing.accordionNew.showHidePaddingTop,
      zIndex: theme.spacing.accordionNew.showHideZIndex,
    },
    ".show-hide-box": {
      position: "absolute",
      width: theme.spacing.accordionNew.showHideBoxWidth,
      height: theme.spacing.accordionNew.showHideBoxHeight,
      right: theme.spacing.accordionNew.showHideBoxRight,
      top: theme.spacing.accordionNew.showHideBoxTop,
      borderTopRightRadius: theme.spacing.accordionNew.showHideBoxBorderRadius,
      borderBottomRightRadius:
        theme.spacing.accordionNew.showHideBoxBorderRadius,
      backgroundColor: theme.customBackgrounds.accordionPlus,
      borderLeft: theme.customColors.accordionPlusBorder,
    },
    ".show-hide.hide": {
      left: theme.spacing.accordionNew.showTextLeft,
      position: "relative",
    },
    ".mantine-Accordion-label": {
      overflow: "visible",
    },
  },
}));
